export default __webpack_public_path__ + "static/media/640x300_05.de1e5f37.jpg";